import React from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import {
  ToolImageStats,
  ToolImageUploadDataGrid,
} from "../components/labToolSimulations";

const LabToolSimulations = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <ToolImageStats />
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }} >
          <Card variant="outlined">
            <CardHeader title="Available Lab Truncation Tools"></CardHeader>
            <CardContent sx={{ padding: 0 }}>
              <ToolImageUploadDataGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default LabToolSimulations;
